
export default{
    // @Driver
    newCreatedDriver: {},
    updateHeaderSites: null,
    showDriverProfileModal: false
}